// Desabilita o patch do evento `unload` pelo zone.js.
// Chrome 128+ bloqueia esse evento por padrão (depreciação para habilitar bfcache).
// Este arquivo DEVE ser carregado antes de zone.js (configurado como primeiro polyfill em angular.json).
(window as any).__Zone_disable_unload = true;
